module.exports = __webpack_public_path__ + "img/eyes_male_average_mask.fd8be099.png";